import React, { useState, useRef, useEffect } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaFilter } from "react-icons/fa";

const FilterComponent = ({
  filterOptions = [],
  onApplyFilter,
  filterLabel = "Filter",
  resetLabel = "Reset Filter",
  applyLabel = "Apply",
  variant = "",
  
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    setSelectedFilters({});
  }, [filterOptions?.length]);

  const groupedFilters = filterOptions.reduce((acc, option) => {
    const { label } = option;
    if (!acc[label]) {
      acc[label] = [];
    }
    acc[label].push(option);
    return acc;
  }, {});

  const handleFilterChange = (filterKey, value) => {
    setSelectedFilters((prev) => {
      const newFilters = { ...prev };
      const currentValues = newFilters[filterKey] || [];

      const valuesToProcess = Array.isArray(value) ? value : [value];

      const allSelected = valuesToProcess.every((val) =>
        currentValues.includes(val)
      );

      if (allSelected) {
        newFilters[filterKey] = currentValues.filter(
          (val) => !valuesToProcess.includes(val)
        );
      } else {
        newFilters[filterKey] = [
          ...currentValues,
          ...valuesToProcess.filter((val) => !currentValues.includes(val)),
        ];
      }

      if (newFilters[filterKey].length === 0) {
        delete newFilters[filterKey];
      }

      return newFilters;
    });
    
  };

  const handleApply = () => {
    if (onApplyFilter) {
      onApplyFilter(selectedFilters);
    }
    setShowFilters(false);
  };

  const handleReset = () => {
    setSelectedFilters({});
  };

  return (
    <div className="position-relative">
      <Button
        ref={dropdownRef}
        variant={variant}
        onClick={() => setShowFilters(!showFilters)}
        className={`
          ${
            Object.entries(selectedFilters).length ? "btn-primary" : "bg-white"
          } shadow-sm`}
      >
        <FaFilter title={t(filterLabel)} />{" "}
        {/* <span>
          {Object.entries(selectedFilters).map(([category, values]) => (
            <strong className="badge bg-primary me-1" key={category}>
              {t(category)}
            </strong>
          ))}
        </span> */}
      </Button>

      {showFilters && (
        <Card
          className="p-3 mt-2 shadow position-absolute bg-white"
          style={{ width: "300px", zIndex: 1050, right: 0 }}
        >
          <h6 className="mb-3">{t(filterLabel)}</h6>

          {Object.entries(groupedFilters).map(([label, options]) => (
            <Form.Group key={label} className="mb-3">
              <Form.Label>{t(options[0]?.category)}</Form.Label>
              {options.map(({ key, value }) => (
                <Form.Check
                  key={key}
                  type="checkbox"
                  label={key}
                  checked={(selectedFilters[label] || []).some((item) =>
                    Array.isArray(value) ? value.includes(item) : item === value
                  )}
                  onChange={() => handleFilterChange(label, value)}
                />
              ))}
            </Form.Group>
          ))}

          <div className="d-flex justify-content-between">
            <Button
              variant="outline-primary"
              onClick={handleReset}
              className="w-50 me-2"
            >
              {t(resetLabel)}
            </Button>
            <Button variant="primary" onClick={handleApply} className="w-50">
              {t(applyLabel)}
            </Button>
          </div>
        </Card>
      )}
    </div>
  );
};

export default FilterComponent;
